/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React,{useEffect,useState,useRef} from 'react'
import moment from 'moment';
import ThreeDotsLoader from '../../Components/LoadingDots';
import CheckboxComponent from './CheckboxComponent';
import ResponsiveFilter from './ResponsiveFilter';
import { Calendar } from 'react-calendar';

function Filters({Filters,setfilters,generateUrl,handleClear,loading,setresponsivePopup,responsivePopup,yeskey,dateselected, setdateselected, tab,}) {
    const dateRef = useRef();
    const toggleState = {
        start_date: false,
        end_date: false,
    };
    const [toggle, settoggle] = useState(toggleState);
    
    const handleToggle = (key) => {
        settoggle((prevState) => ({
            ...prevState,
            [key]: !toggle[key],
        }));
    };
    const handleDate = (val, key) => {
        const state = key === 'start_date' ? 'end_date' : 'start_date';
        if (key === 'start_date') {
            setdateselected((prevState) => ({
                ...prevState,
                end_date: '',
            }));
        }
        handleToggle(state)
        setdateselected((prevState) => ({
            ...prevState,
            [key]: val,
        }));
        settoggle(toggleState);
    };
    // useEffect(() => {
    //     const datepickerEl = document?.getElementById("datepickerId");
    //     const datepickerEl1 = document?.getElementById("datepickerId1")     
    //     new Datepicker(datepickerEl, {});
    //     console.log(Filters.start_date)
    //     if(Filters.start_date !== ''){
    //         new Datepicker(datepickerEl1, {startDate:Filters.start_date});
    //     }else{
    //         new Datepicker(datepickerEl1, {});}
    // }, [update]);
    const [loading1, setloading] = useState(false);

    useEffect(() => {
        const handler = (event) => {
            if (dateRef && !dateRef.current.contains(event.target)) {
                settoggle((prevState) => ({
                    ...prevState,
                    start_date: false,
                    end_date: false,
                }));
                // setNotificationDropdown(false)
                // setReportsDropdown(false)
            }
        };
        document.addEventListener('mousedown', handler);

        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, [dateRef]);

    
    return (
        <>
            <div className=" xl:block hidden w-[22%] fixed top-[88px] p-[17px] border-r-[1px] h-screen sidebar overflow-auto" style={{pointerEvents:`${loading?'none':''}`}}>
                <div className="flex justify-between items-center">
                    <p className="text-[#15090E] font-bold text-lg">Filter by</p>
                    <p className="text-[#ED1C24] font-semibold text-xs cursor-pointer" onClick={()=>handleClear()}>Clear All</p>
                </div>
                <div className="overflow-auto pb-4 sidebar" style={{height :"calc(100vh - 179px)"}}>
                    {yeskey === true ?
                        <><p className="text-[#555259] font-bold text-xs7 mt-5">Offer Type</p><ul>
                            <li>
                                <div className="px-1 mt-4">
                                    <div className="relative flex items-center">
                                        <CheckboxComponent type="Special" Filters={Filters} setfilters={setfilters} id="checkbox-11"/>
                                        <label htmlFor="checkbox-11" className="pl-3 text-base font-normal text-[#555259] cursor-pointer">Special Offers</label>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="px-1 mt-4">
                                    <div className="relative flex items-center">
                                        <CheckboxComponent type="Standard" Filters={Filters} setfilters={setfilters} />
                                        <label htmlFor="checkbox-21" className="pl-3 text-base font-normal text-[#555259] cursor-pointer">Standard Offers</label>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="px-1 mt-4">
                                    <div className="relative flex items-center">
                                        <CheckboxComponent type="Special Recurring" Filters={Filters} setfilters={setfilters} />
                                        <label htmlFor="checkbox-22" className="pl-3 text-base font-normal text-[#555259] cursor-pointer">Special Recurring Offers</label>
                                    </div>
                                </div>
                            </li>
                        </ul></> : null
                    }
                    <p className="text-[#555259] font-bold text-xs7 mt-5">Expiring on</p>
                    <div ref={dateRef} className="flex items-center mt-3 relative filter-date">
                        <div className="relative w-1/2" onClick={() => handleToggle('start_date')}>
                            <label className="text-[#555259] font-normal text-xs2 pb-1">Start Date</label>
                            <img 
                            
                                src="images/down-arrow.svg" alt="icon" className="absolute top-[34px] right-3 cursor-pointer"/>
                            <input 
                                datepicker 
                                datepicker-autohide 
                                type="text" 
                                value={dateselected.start_date === '' ? '' : moment(dateselected.start_date).format('YYYY/MM/DD').split('/').reverse()
                                    .join('/')}
                                className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs6 placeholder:font-normal placeholder:text-[#808285]" 
                                placeholder="From Date" />
                        </div>
                        {toggle.start_date && (
                            <Calendar
                                value={moment(dateselected.start_date).format('YYYY/MM/DD').start_date}
                                onChange={(val) => handleDate(val, 'start_date')}
                                placeholder="Date from"
                                minDate={tab === 'subscribed_offer' ? '' :  new Date()}
                            />
                        )}
                        <p className="text-base font-normal text-[#555259] px-2.5"></p>
                        <div className="relative w-1/2" onClick={() => handleToggle('end_date')}>
                            <label className="text-[#555259] font-normal text-xs2 pb-1">End Date</label>
                            <img 
                            
                                src="images/down-arrow.svg" alt="icon" className="absolute top-[34px] right-3 cursor-pointer"/>
                            <input 
                                datepicker 
                                datepicker-autohide 
                                type="text" 
                                value={dateselected.end_date === '' ? '' : moment(dateselected.end_date).format('YYYY/MM/DD').split('/').reverse()
                                    .join('/')}
                                className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs6 placeholder:font-normal placeholder:text-[#808285]" 
                                placeholder="To Date" 
                            />
                        </div>
                        {toggle.end_date && dateselected.start_date !== '' && (
                            <Calendar
                                value={(dateselected.end_date)}
                                onChange={(val) => handleDate(val, 'end_date')}
                                placeholder="Date to"
                                minDate={moment(dateselected.start_date).toDate()}
                            />
                        )}
                
                    </div>
                    <button 
                        onClick={()=>{
                            setloading(true);
                            setTimeout(() => {
                                setloading(false)
                            }, 1000);
                            generateUrl() 
                        }}
                        type="button" className="bg-[#555259] h-10 w-full rounded-lg text-[#FFFFFF] font-semibold text-sm mt-10 flex items-center justify-center">
                        <>{!loading1?'Apply Filter':<ThreeDotsLoader />}</>
                    </button>
                </div>
            </div>
            <ResponsiveFilter
                responsivePopup={responsivePopup}
                setresponsivePopup={setresponsivePopup}
                handleDate={handleDate}
                Filters={Filters}
                setfilters={setfilters}
                generateUrl={generateUrl}
                handleClear={handleClear}
                loading={loading}
                loading1={loading1}
                setloading={setloading}/>
        </>
    )
}
export default Filters